import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
    >
      <g fill={color} fill-rule="evenodd">
        <path
          d="M13.9459432,0.5 C14.3578037,0.5 14.7305853,0.667734923 15.0004596,0.938655278 C15.2710326,1.21027708 15.4382208,1.58556451 15.4382208,2 L15.4382208,2 L15.4382208,10 C15.4382208,10.4144355 15.2710326,10.7897229 15.0004596,11.0613447 C14.7305853,11.3322651 14.3578037,11.5 13.9459432,11.5 L13.9459432,11.5 L9.2239301,11.5 L8.42951676,13.4937315 L6.71429073,11.5 L1.9922776,11.5 C1.58041709,11.5 1.2076355,11.3322651 0.937761218,11.0613447 C0.667188203,10.7897229 0.5,10.4144355 0.5,10 L0.5,10 L0.5,2 C0.5,1.58556451 0.667188203,1.21027708 0.937761218,0.938655278 C1.2076355,0.667734923 1.58041709,0.5 1.9922776,0.5 L1.9922776,0.5 Z"
          stroke="#758697"
          transform="translate(0 1)"
        />
        <path
          d="M4.18378297,7.06979634 C4.73393524,7.06979634 5.17992177,6.62208109 5.17992177,6.06979634 C5.17992177,5.51751159 4.73393524,5.06979634 4.18378297,5.06979634 C3.6336307,5.06979634 3.18764417,5.51751159 3.18764417,6.06979634 C3.18764417,6.62208109 3.6336307,7.06979634 4.18378297,7.06979634 Z"
          fill="#758697"
          transform="translate(0 1)"
        />
        <path
          d="M8.16833817,7.06979634 C8.71849044,7.06979634 9.16447697,6.62208109 9.16447697,6.06979634 C9.16447697,5.51751159 8.71849044,5.06979634 8.16833817,5.06979634 C7.6181859,5.06979634 7.17219937,5.51751159 7.17219937,6.06979634 C7.17219937,6.62208109 7.6181859,7.06979634 8.16833817,7.06979634 Z"
          fill="#758697"
          transform="translate(0 1)"
        />
        <path
          d="M12.1528934,7.06979634 C12.7030456,7.06979634 13.1490322,6.62208109 13.1490322,6.06979634 C13.1490322,5.51751159 12.7030456,5.06979634 12.1528934,5.06979634 C11.6027411,5.06979634 11.1567546,5.51751159 11.1567546,6.06979634 C11.1567546,6.62208109 11.6027411,7.06979634 12.1528934,7.06979634 Z"
          fill="#758697"
          transform="translate(0 1)"
        />
      </g>
    </svg>
  )
}

const CommentIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default CommentIcon
